
import * as Cookies from 'js-cookie/src/js.cookie.js';

import Request from './request.js';


var referralCodeParameterName = 'grsf';

const getReferralCode = function() {
  var referralCode = Request.getParameterByName(referralCodeParameterName);

  // if there's no referral code set in the request, check the cookie value
  if (! referralCode) {
    referralCode = Cookies.get(referralCodeParameterName);
  }


  return referralCode;
};


// if the request contains a referral code, set a cookie to remember the code
// for the next 3 days, so a returning subscriber is still given credit for the
// referral.
(function(jQuery) {
  var referralCode = Request.getParameterByName(referralCodeParameterName);

  if (referralCode) {
    Cookies.set(referralCodeParameterName, referralCode, { expires: 3 });
  }
})(jQuery);


export { referralCodeParameterName, getReferralCode };

